<template>
  <div>
    <div class="mesgboxtop">
      <!-- 图片预览模态框 -->
      <div class="image-preview-modal" v-if="showPreview" @click="closePreview">
        <div class="preview-content" @click.stop>
          <img :src="previewImageSrc" class="preview-image" alt="预览图" />
          <div class="close-btn" @click="closePreview">×</div>
        </div>
      </div>
      <div
        class="flex-centerCloumn paddingtb1"
        style="border-bottom: 1px solid #e1e1e1;"
      >
        <img
          class="mesgimg"
          :src="packageDetail.product ? packageDetail.product.thumb : ''"
        />
        <div class="textfont maincolor">核销信息</div>
      </div>

      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">卡券信息</div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约卡券</div>
          <div class="textfont">{{ packageDetail.name }}</div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约服务</div>
          <div class="textfont">
            {{ packageDetail.product ? packageDetail.product.name : "" }}
          </div>
        </div>
        <!-- <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">预约日期</div>
          <div class="textfont">{{packageDetail.created_at}}</div>
        </div> -->
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">手机号</div>
          <div class="textfont">
            {{ packageDetail.related ? packageDetail.related.mobile : "" }}
          </div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">卡券状态</div>
          <div class="textfont">{{ packageDetail.status_str }}</div>
        </div>
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">位置信息</div>
          <div class="textfont">{{ address }}</div>
        </div>
        <!--        <div class="flexbetween marginbottom1">-->
        <!--          <div class="textfont tipcolor1">经纬度</div>-->
        <!--          <div class="textfont">{{ longitude }}、{{ latitude }}</div>-->
        <!--        </div>-->
        <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">车牌号</div>
          <input
            class="carcode-input"
            v-model="carNo"
            :disabled="isdisabled"
            placeholder="请输入车牌号"
          />
        </div>
      </div>
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">车牌照片</div>
        </div>
        <div class="imgsbox">
          <div>
            <div v-if="showLoading" class="verifyImgtop">
              <van-loading type="spinner" color="#1989fa" />
            </div>
            <div @click="chooseimg" v-else class="verifyImgtop">
              <div v-if="image" class="img-with-delete">
                <img class="verifyimg" :src="image" />
                <div class="delete-btn" @click.stop="deleteLicenseImg"></div>
              </div>
              <img v-else class="verifyimg" src="/static/photo.png" />
              <div class="textfont maincolor">请拍摄包含车牌的车身照</div>
            </div>
          </div>
          <div>
            <div class="examplebox" @click="previewImage(exampleImages.car)">
              <div class="exampletext">示例图</div>

              <img :src="exampleImages.car" class="example" alt="车牌示例图" />
            </div>
          </div>
        </div>
        <!-- <div class="flexbetween marginbottom1">
          <div class="textfont tipcolor1">车牌号</div>
          <input class="carcode-input" v-model="carNo" placeholder="请输入车牌号" />
        </div> -->

        <!-- <div class="carlicenseadd-upimgbox11">
          <div v-if="image" class="verifyImgtop">
            <img class="verifyimg" src="/static/photo.png" />
            <div class="textfont maincolor">请拍摄包含车牌的车身照</div>
          </div>
          <div v-else class="carlicenseadd-upimgbox1">
            <img class="verifyimg" :src="image" />
          </div>
          <input type="file" class="fileinput" accept="image/*" @change='getimgmain($event)' />
        </div> -->
      </div>
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">施工照片</div>
        </div>
        <div class="construction-upload-container">
          <!-- 显示已上传的施工照片 -->
          <div
            v-if="showConstructionLoading"
            class="verifyImgtop marginbottom1"
          >
            <van-loading type="spinner" color="#1989fa" />
          </div>
          <div v-else class="construction-upload-grid">
            <!-- 已上传的照片 -->
            <div
              v-for="(img, index) in constructionImgs"
              :key="index"
              class="construction-upload-item"
            >
              <img :src="img" class="construction-upload-img" />
              <div
                class="delete-btn"
                @click="deleteConstructionImg(index)"
              ></div>
            </div>
            <!-- 添加照片按钮 -->
            <div
              @click="chooseConstructionImg"
              :class="[
                'construction-upload-add',
                constructionImgs.length === 0 ? 'empty-state' : ''
              ]"
            >
              <img class="verifyimg" src="/static/photo.png" />
              <div class="textfont maincolor">
                {{
                  constructionImgs.length > 0
                    ? "添加照片"
                    : "请拍摄包含车牌的施工照片"
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- 施工示例图 -->
        <div class="construction-examples">
          <!-- <div class="exampletext">示例图</div> -->
          <div class="examples-list">
            <div
              v-for="(item, index) in exampleImages.construction"
              :key="index"
              class="construction-example-item"
              @click="previewImage(item.url)"
            >
              <div class="construction-example-label">{{ item.label }}</div>
              <img :src="item.url" class="example" alt="施工示例图" />
            </div>
          </div>
        </div>
      </div>
      <div class="addbotton margintb1" @click="buttonClicked ? '' : writeOff()">
        确定核销
      </div>
      <div class="flexAllcenter">
        <div class="textfont tipcolor1 ">
          如遇使用问题，请联系客服<a href="tel:4008932218">4008932218</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httper from "../../../api/http";
import { Dialog } from "vant";
export default {
  data() {
    return {
      carNo: "", //车牌
      cardNo: "", //卡券
      packageDetail: {}, //卡券详情
      image: "", // 车身照，默认为空
      phoneNum: "", //客服电话
      source: "ant",
      imgs: [],
      localIds: "",
      showLoading: false,
      buttonClicked: false, // 防止重复点击,默认为false
      isdisabled: true, // 没有识别出车牌时可手动输入车牌号,默认true
      longitude: "", // 经度
      latitude: "", // 纬度
      address: "", // 地址信息
      constructionImage: "", // 施工照片，默认为空
      constructionImgs: [], // 施工照片数组
      showConstructionLoading: false, // 施工照片加载状态
      userInfo: {},
      // 图片预览相关
      showPreview: false, // 是否显示图片预览
      previewImageSrc: "", // 预览图片的URL
      // 示例图片列表
      exampleImages: {
        car: "/static/chepaizhao.jpg", // 车牌示例图
        construction: [
          { label: "洗车示例", url: "/static/xiche.jpg" }, // 洗车示例图
          { label: "保养示例", url: "/static/baoyang.jpg" }, // 保养示例图
          { label: "补胎示例", url: "/static/butai.jpg" }, // 补胎示例图
          { label: "打蜡示例", url: "/static/dala.jpg" }, // 打蜡示例图
          { label: "空调清洗示例", url: "/static/kongtiaoqingxi.jpg" }, // 空调清洗示例图
          { label: "喷漆示例", url: "/static/penqi.jpg" }, // 喷漆示例图
          { label: "四轮定位示例", url: "/static/silundingwei.jpg" }, // 四轮定位示例图
          { label: "其他示例", url: "/static/xiaodu.jpg" } // 车内消毒示例图
        ]
      }
    };
  },
  created() {
    // if (this.$route.query.cardNo) {
    //   this.cardNo = this.$route.query.cardNo
    //   this.request("packageDetail", {
    //     source: this.source,
    //     card_no: this.cardNo
    //   })
    // }else{}
    let userinfo = localStorage.getItem("userinfo");
    this.userInfo = JSON.parse(userinfo);
    let login_href = window.location.href;
    this.source = this.getSourceByName("source");
    this.cardNo = this.getSourceByName("card_no");
    this.request("packageDetail", {
      source: this.source,
      card_no: this.cardNo
    });

    // 获取完整的URL（不包含hash部分）
    // 对于本地开发环境，使用实际部署的域名进行签名，因为微信JS-SDK需要在配置的域名下才能正常工作
    const currentUrl = location.href.split("#")[0];
    const isLocalhost =
      location.hostname === "localhost" || location.hostname === "127.0.0.1";

    let signatureUrl = currentUrl;
    if (isLocalhost) {
      // 如果是本地开发环境，可以使用生产环境或测试环境的URL进行签名
      // 这里可以根据实际情况配置，例如使用环境变量或配置文件
      console.log(
        "当前为本地开发环境，使用当前URL进行微信签名，这可能导致微信JS-SDK配置失败"
      );
      // 注意：在实际开发中，你可能需要配置一个代理或使用生产环境的URL进行签名
    }

    this.getwechat({
      url: signatureUrl
    });

    // 获取定位信息
    this.getLocation();
  },
  mounted() {},
  methods: {
    // 删除车牌照片
    deleteLicenseImg() {
      let that = this;
      Dialog.confirm({
        title: "确认删除",
        message: "确定要删除这张车牌照片吗？"
      })
        .then(() => {
          that.image = "";
          that.imgs = [];
          that.$toast({ message: "删除成功" });
        })
        .catch(() => {
          // 取消删除
        });
    },
    // 删除施工照片
    deleteConstructionImg(index) {
      let that = this;
      Dialog.confirm({
        title: "确认删除",
        message: "确定要删除这张施工照片吗？"
      })
        .then(() => {
          that.constructionImgs.splice(index, 1);
          if (that.constructionImgs.length === 0) {
            that.constructionImage = "";
          }
          that.$toast({ message: "删除成功" });
        })
        .catch(() => {
          // 取消删除
        });
    },
    // 获取定位信息
    getLocation() {
      let that = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function(position) {
            that.longitude = position.coords.longitude;
            that.latitude = position.coords.latitude;
            // 调用逆地理编码接口获取地址信息
            that.getAddressInfo(that.longitude, that.latitude);
            // 调用位置距离检查接口
            that.checkDistance(that.longitude, that.latitude);
          },
          function(error) {
            // that.getAddressInfo("113.35973286245161", "22.494830584045985");
            console.error("获取定位失败:", error.message);
            that.$toast({
              message: "获取定位失败，请检查位置权限"
            });
          }
        );
      } else {
        that.$toast({
          message: "您的浏览器不支持地理定位"
        });
      }
    },
    // 图片预览方法
    previewImage(imageSrc) {
      this.previewImageSrc = imageSrc;
      this.showPreview = true;
    },
    // 关闭图片预览
    closePreview() {
      this.showPreview = false;
      this.previewImageSrc = "";
    },
    // 位置距离检查
    checkDistance(lng, lat) {
      let that = this;
      const requestData = {
        source: that.source,
        longitude: lng,
        latitude: lat
      };

      that.request("checkDistance", requestData);
    },
    // 获取地址信息（前端反向地理编码）
    getAddressInfo(lng, lat) {
      let that = this;
      // 创建FormData对象传递经纬度
      const formData = new FormData();
      formData.append("latitude", lat);
      formData.append("longitude", lng);

      // 调用后端接口获取地址
      that.request("getAddressInfo", formData);
    },
    // base64转Blob
    base64ToBlob(base64, contentType = "image/jpeg") {
      try {
        // 移除base64前缀（如果有）
        const base64Data =
          base64.indexOf(",") >= 0 ? base64.split(",")[1] : base64;
        // 解码base64
        const bytes = window.atob(base64Data);
        // 创建ArrayBuffer和Uint8Array
        const ab = new ArrayBuffer(bytes.length);
        const ia = new Uint8Array(ab);
        // 将解码后的字符转换为字节
        for (let i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i);
        }
        // 创建并返回Blob对象
        return new Blob([ab], { type: contentType });
      } catch (error) {
        console.error("base64ToBlob转换失败:", error);
        return null;
      }
    },
    //获取链接后参数
    getSourceByName(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.search);
      if (results == null) {
        return "";
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    },
    //获取微信配置信息接口
    getwechat(requestData = {}) {
      // 检测是否可以使用微信SDK
      if (this.canUseWechatSDK()) {
        console.log("正在微信环境中获取配置，请求数据:", requestData);

        httper.get(
          "wechat/wechat/sign-package",
          requestData,
          res => {
            console.log("微信配置数据:", res);
            if (res.code === 0) {
              // 确保微信配置的参数正确
              const configData = {
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名
                jsApiList: ["chooseImage", "getLocalImgData"] // 必填，需要使用的JS接口列表
              };

              console.log("微信JS-SDK配置参数:", configData);

              wx.config(configData);

              // 微信SDK配置成功回调
              wx.ready(() => {
                console.log("微信SDK配置成功");
              });

              // 微信SDK配置失败回调
              wx.error(res => {
                console.error("微信SDK配置失败:", res);
                // 根据错误类型提供更详细的错误信息
                let errorMessage = "微信SDK配置失败，请稍后重试";
                if (res.errMsg && res.errMsg.includes("invalid url domain")) {
                  errorMessage = "当前域名未在微信公众号中配置，请联系管理员";
                  console.warn(
                    "微信JS-SDK配置失败：当前域名未在微信公众号中配置"
                  );
                }
                this.$toast({
                  message: errorMessage
                });
              });
            } else {
              console.error("获取微信配置失败:", res.message);
              this.$toast({ message: "获取微信配置失败: " + res.message });
            }
          },
          error => {
            console.error("请求微信配置时发生错误:", error);
            this.$toast({ message: "网络请求失败，请稍后重试" });
          }
        );
      } else if (this.isInWechat()) {
        // 在微信环境中但不能使用SDK（通常是localhost环境）
        console.warn(
          "当前为本地开发环境，微信JS-SDK无法正常工作，因为localhost域名未在微信公众号中配置"
        );
        this.$toast({
          message: "当前为本地环境，微信功能可能受限"
        });
      } else {
        console.log("当前不在微信环境中，无法使用微信JS-SDK");
      }
    },

    // 检测是否在微信环境中
    isInWechat() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes("micromessenger");
    },

    // 检测是否为本地开发环境
    isLocalhost() {
      return (
        location.hostname === "localhost" || location.hostname === "127.0.0.1"
      );
    },

    // 检测是否可以使用WeChat SDK（不在本地环境或有特殊配置）
    canUseWechatSDK() {
      return this.isInWechat() && !this.isLocalhost();
    },

    chooseimg() {
      // 检测是否可以使用微信SDK，否则使用HTML5上传
      if (this.canUseWechatSDK() && typeof wx !== "undefined") {
        this.chooseImageWechat();
      } else {
        this.chooseImageHtml5();
      }
    },

    // 微信环境下的图片选择
    chooseImageWechat() {
      let that = this;

      wx.ready(() => {
        console.log("准备调用微信chooseImage");
        const canAlbum = this.userInfo.store_can_album != 0;
        const sourceType = canAlbum ? ["album", "camera"] : ["camera"];
        wx.chooseImage({
          count: 9, // 默认9
          sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType, // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {
            console.log("选择图片成功:", res);
            var localIds = res.localIds[0]; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            console.log("localIds111", localIds);
            that.showLoading = true;

            // 使用微信SDK获取图片数据
            wx.getLocalImgData({
              localId: localIds,
              success: function(res) {
                console.log("获取本地图片数据成功:", res);
                var localData = res.localData;
                let base64 = null;

                // 处理不同平台返回的数据格式
                if (localData.indexOf("data:image") === 0) {
                  // iOS平台：直接获取base64部分
                  base64 = localData.split(",")[1];
                } else if (localData.indexOf("/9j/") === 0) {
                  // Android平台：直接是base64数据（JPEG格式）
                  base64 = localData;
                } else {
                  // 其他情况：尝试提取base64
                  base64 = localData;
                }

                if (base64) {
                  // 转换base64为Blob对象
                  const blob = that.base64ToBlob(base64, "image/jpeg");
                  console.log("blob", blob);
                  if (blob) {
                    // 创建FormData对象
                    const formData = new FormData();
                    formData.append("source", that.source);
                    formData.append("address", that.address || "");
                    formData.append("files", blob, "car_license.jpg");

                    // 检查FormData内容
                    console.log("FormData对象:", formData);
                    for (let [key, value] of formData.entries()) {
                      console.log(`${key}: ${value}`);
                    }

                    that.request("upload", formData);
                  } else {
                    console.error("Blob对象创建失败");
                    that.showLoading = false;
                    that.$toast({ message: "图片处理失败" });
                  }
                } else {
                  console.error("无法提取base64数据");
                  that.showLoading = false;
                  that.$toast({ message: "图片数据获取失败" });
                }
              },
              fail: function(error) {
                console.error("getLocalImgData失败:", error);
                that.showLoading = false;
                that.$toast({ message: "获取本地图片数据失败" });
              }
            });
          },
          fail: function(error) {
            console.error("chooseImage失败:", error);
            that.$toast({ message: "选择图片失败" });
          }
        });
      });

      // 添加微信SDK未就绪的处理
      wx.error(error => {
        console.error("微信SDK错误:", error);
        let errorMessage = "微信SDK未就绪，请稍后重试";
        if (error.errMsg && error.errMsg.includes("invalid url domain")) {
          errorMessage = "当前域名未在微信公众号中配置，请联系管理员";
          console.warn("微信JS-SDK错误：当前域名未在微信公众号中配置");
        }
        that.$toast({ message: errorMessage });
      });
    },

    // HTML5环境下的图片选择
    chooseImageHtml5() {
      let that = this;

      // 创建隐藏的文件输入元素
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.capture = "environment"; // 优先使用后置摄像头

      fileInput.onchange = function(event) {
        const file = event.target.files[0];
        if (!file) return;

        that.showLoading = true;

        // 创建FormData对象
        const formData = new FormData();
        formData.append("source", that.source);
        formData.append("address", that.address || "");
        formData.append("files", file, file.name || "car_license.jpg");

        // 检查FormData内容
        console.log("HTML5 FormData对象:", formData);
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }

        that.request("upload", formData);
      };

      fileInput.click();
    },
    // 选择施工照片
    chooseConstructionImg() {
      // 检测是否可以使用微信SDK，否则使用HTML5上传
      if (this.canUseWechatSDK() && typeof wx !== "undefined") {
        this.chooseConstructionImageWechat();
      } else {
        this.chooseConstructionImageHtml5();
      }
    },

    // 微信环境下的施工图片选择
    chooseConstructionImageWechat() {
      let that = this;
      const canAlbum = this.userInfo.store_can_album != 0;
      const sourceType = canAlbum ? ["album", "camera"] : ["camera"];
      wx.ready(() => {
        console.log("准备调用微信chooseImage(施工照片)");
        wx.chooseImage({
          count: 9, // 默认9
          sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType, // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {
            console.log("选择施工图片成功:", res);
            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            console.log("construction localIds", localIds);
            that.showConstructionLoading = true;

            // 处理多张图片
            const uploadPromises = localIds.map((localId, index) => {
              return new Promise((resolve, reject) => {
                // 使用微信SDK获取图片数据
                wx.getLocalImgData({
                  localId: localId,
                  success: function(res) {
                    console.log(`获取施工图片${index + 1}本地数据成功:`, res);
                    var localData = res.localData;
                    let base64 = null;

                    // 处理不同平台返回的数据格式
                    if (localData.indexOf("data:image") === 0) {
                      // iOS平台：直接获取base64部分
                      base64 = localData.split(",")[1];
                    } else if (localData.indexOf("/9j/") === 0) {
                      // Android平台：直接是base64数据（JPEG格式）
                      base64 = localData;
                    } else {
                      // 其他情况：尝试提取base64
                      base64 = localData;
                    }

                    if (base64) {
                      // 转换base64为Blob对象
                      const blob = that.base64ToBlob(base64, "image/jpeg");
                      resolve(blob);
                    } else {
                      reject(new Error("无法提取施工照片base64数据"));
                    }
                  },
                  fail: function(error) {
                    reject(new Error("获取本地图片数据失败"));
                  }
                });
              });
            });

            // 等待所有图片处理完成
            Promise.all(uploadPromises)
              .then(blobs => {
                // 创建FormData对象，上传所有图片
                const formData = new FormData();
                formData.append("source", that.source);
                formData.append("address", that.address || "");

                // 添加所有图片
                blobs.forEach((blob, index) => {
                  formData.append(
                    "files",
                    blob,
                    `construction_${index + 1}.jpg`
                  );
                });

                // 检查FormData内容
                console.log("施工照片FormData对象:", formData);
                for (let [key, value] of formData.entries()) {
                  console.log(`${key}: ${value}`);
                }

                that.request("uploadConstruction", formData);
              })
              .catch(error => {
                console.error("施工照片处理失败:", error);
                that.showConstructionLoading = false;
                that.$toast({ message: "施工照片处理失败" });
              });
          },
          fail: function(error) {
            console.error("chooseImage(施工照片)失败:", error);
            that.$toast({ message: "选择施工图片失败" });
          }
        });
      });

      // 添加微信SDK未就绪的处理
      wx.error(error => {
        console.error("微信SDK错误(施工照片):", error);
        let errorMessage = "微信SDK未就绪，请稍后重试";
        if (error.errMsg && error.errMsg.includes("invalid url domain")) {
          errorMessage = "当前域名未在微信公众号中配置，请联系管理员";
          console.warn("微信JS-SDK错误：当前域名未在微信公众号中配置");
        }
        that.$toast({ message: errorMessage });
      });
    },

    // HTML5环境下的施工图片选择
    chooseConstructionImageHtml5() {
      let that = this;

      // 创建隐藏的文件输入元素
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.multiple = true; // 支持选择多张图片
      fileInput.capture = "environment"; // 优先使用后置摄像头

      fileInput.onchange = function(event) {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        that.showConstructionLoading = true;

        // 创建FormData对象
        const formData = new FormData();
        formData.append("source", that.source);
        formData.append("address", that.address || "");

        // 添加所有选择的图片
        for (let i = 0; i < files.length; i++) {
          formData.append(
            "files",
            files[i],
            files[i].name || `construction_${i + 1}.jpg`
          );
        }

        // 检查FormData内容
        console.log("HTML5施工照片FormData对象:", formData);
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }

        that.request("uploadConstruction", formData);
      };

      fileInput.click();
    },
    // uploadimg(localIds) {
    //   let that = this
    //   wx.ready(() => {
    //     wx.uploadImage({
    //       localId: localIds, // 需要上传的图片的本地ID，由chooseImage接口获得
    //       isShowProgressTips: 1, // 默认为1，显示进度提示
    //       success: function(res) {
    //         console.log("res111", res)
    //         var serverId = res.serverId; // 返回图片的服务器端ID
    //         that.request('upload', {
    //           media_id: serverId,
    //           source: that.source,
    //           type: "image",
    //           category: "merchant"
    //         })
    //       }
    //     });
    //   });
    // },
    // getimgmain(e) {
    //   let that = this;
    //   let requestData = {}
    //   var files = e.target.files[0];
    //   if (!files) return
    //   let reader = new FileReader();
    //   reader.readAsDataURL(files); // 读取文件
    //   reader.onloadend = function(res) {
    //     that.showmain = false;
    //     requestData.base64_file = res.currentTarget.result;
    //     requestData.type = "driving"
    //     requestData.side = "face"
    //     that.request("upimg", requestData)
    //   }
    // },
    /**
     * 防重点击
     * @param duration
     * @returns {Promise<any>}
     */
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },
    // 核销
    writeOff() {
      let that = this;
      that.buttonClickedFun(2000);

      // 验证图片数量（至少需要2张图片）
      if (that.imgs.length + that.constructionImgs.length < 2) {
        that.$toast({
          message: "请至少上传2张图片（车牌照片和施工照片）"
        });
        return;
      }
      if (!that.carNo) {
        that.$toast({
          message: "请输入车牌号"
        });
        return;
      }

      // 合并车牌照片和施工照片为一个数组
      const allImages = [...that.imgs, ...that.constructionImgs];

      // 创建FormData对象
      const formData = new FormData();
      formData.append("package_id", this.packageDetail.id);
      formData.append("source", this.source);
      formData.append("car_no", this.carNo);
      formData.append("address", this.address || "");
      formData.append("latitude", this.latitude || "");
      formData.append("longitude", this.longitude || "");
      // 添加备注字段（如果需要的话，可以设置为空字符串）"113.35973286245161", "22.494830584045985"
      formData.append("remark", ""); // 或者可以根据业务需求添加具体备注

      // 添加所有图片URL，使用数组格式
      allImages.forEach((imgUrl, index) => {
        formData.append("image[]", imgUrl);
      });

      this.request("wirteOff", formData);
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //卡券详情
        case "packageDetail":
          httper.post(
            "service/package-detail",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.packageDetail = res.data;
              } else {
                // that.$toast({
                //   message: res.message || '操作失败',
                // });
                Dialog.alert({
                  message: res.message || "操作失败"
                }).then(() => {
                  that.$router.push({
                    path: "/"
                  });
                });
              }
            },
            true
          );
          break;
        //核销
        case "wirteOff":
          httper.post(
            "service/write-off-v2",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.$toast({
                  message: "核销成功！"
                });
                that.$router.push({
                  path: "/verifyOrder"
                });
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        //上传图片
        case "upload":
          httper.post(
            "media/upload-with-watermark",
            requestData,
            function(res) {
              if (res.code == 0 && res.data && res.data.length > 0) {
                console.log("res", res);
                // 后端返回数组格式数据，取第一个元素的image_url
                const firstImage = res.data[0];
                that.imgs.push(firstImage.image_url);
                that.image = firstImage.image_url;
                that.showLoading = false;
                that.request("ocrCarNo", {
                  image: firstImage.image_url
                });
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
                that.showLoading = false;
              }
            },
            true
          );
          break;
        // 上传施工照片
        case "uploadConstruction":
          httper.post(
            "media/upload-with-watermark",
            requestData,
            function(res) {
              if (res.code == 0 && res.data && res.data.length > 0) {
                console.log("construction upload res", res);
                // 后端返回数组格式数据，遍历所有图片并添加到constructionImgs数组
                res.data.forEach(imageItem => {
                  that.constructionImgs.push(imageItem.image_url);
                });
                // 如果constructionImgs数组中有图片，将最后一张图片的URL赋值给constructionImage
                if (that.constructionImgs.length > 0) {
                  that.constructionImage =
                    that.constructionImgs[that.constructionImgs.length - 1];
                }
                that.showConstructionLoading = false;
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
                that.showConstructionLoading = false;
              }
            },
            true
          );
          break;
        //上传图片
        // case 'upload':
        //   httper.post('media/base64-upload', requestData, function(res) {
        //     if (res.code == 0) {
        //       console.log("res",res)
        //       // that.request('ocrCarNo', {
        //       //   image: JSON.parse(resp.data).data.url
        //       // })
        //     } else {
        //       that.$toast({
        //         message: res.message || '操作失败',
        //       });
        //     }
        //   }, true)
        //   break
        //识别车牌号
        case "ocrCarNo":
          httper.get(
            "service/ocr-car-no",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.image = requestData.image;
                that.showLoading = false;
                that.carNo = res.data;
                if (that.carNo) {
                  that.isdisabled = true;
                }
              } else {
                that.isdisabled = false;
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        //位置距离检查
        case "checkDistance":
          httper.post(
            "service/check-distance",
            requestData,
            function(res) {
              if (res.code != 0) {
                that.$toast({
                  message: res.message || "位置检查失败"
                });
              }
            },
            true
          );
          break;
        //获取地址接口
        case "getaddress":
        case "getAddressInfo":
          httper.post(
            "sys/geocoder",
            requestData,
            function(res) {
              if (res.code == 0) {
                // 使用正确的返回字段名
                that.address = res.data.formatted_address;
                console.log("获取地址成功:", that.address);
              } else {
                that.$toast({
                  message: res.message || "获取地址失败"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>

<style scoped="scoped">
.mesgboxtop {
  width: calc(100% - 20px);
  margin: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 0 10px;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.packageDesc_shangpinmesg {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  /*    margin-bottom: 20px; */
}

.mesgimg {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  border-radius: 25px;
}
.imgsbox {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.verifyImgtop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 12px;
  background-color: #ffffff;
  border: 2px dashed #d0d0d0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /*    background: linear-gradient(160deg, #1496f1, #E0F0FA); */
}

.verifyImgtop:hover {
  background-color: #f8faff;
  border-color: #1989fa;
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(25, 137, 250, 0.2);
}

.verifyimg {
  width: 80px;
  height: 80px;
  margin-bottom: 12px;
}

/* 图片删除按钮样式 */
.img-with-delete {
  position: relative;
  display: inline-block;
}

.delete-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  background-image: url("/static/del.png");
  background-size: 20px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  transform: scale(1.1);
}

.construction-upload-item {
  position: relative;
}
.exampletext {
  width: 50px;
  height: 30px;
  font-size: 10px;
  background-color: pink;
  position: absolute;
  top: 0;
  left: 0;
}
.example {
  width: 100%;
  height: 100%;
}

.construction-upload-container {
  width: 100%;
}

.construction-upload-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.construction-upload-item {
  width: calc(33.33% - 7px);
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.construction-upload-item:hover {
  transform: scale(1.02);
}

.construction-upload-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.construction-upload-item .delete-btn {
  top: 5px;
  right: 5px;
  width: 30px;
  height: 30px;
  background-size: 20px;
}

.construction-upload-add {
  width: calc(33.33% - 7px);
  aspect-ratio: 1;
  border-radius: 12px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  box-sizing: border-box;
  cursor: pointer;
  border: 2px dashed #d0d0d0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  min-height: 120px;
}

/* 未上传照片时的空状态样式 */
.construction-upload-add.empty-state {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  aspect-ratio: auto;
  min-height: 180px;
}

.construction-upload-add:hover {
  background-color: #f8faff;
  border-color: #1989fa;
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(25, 137, 250, 0.2);
}

.construction-upload-add .verifyimg {
  width: 50px;
  height: 50px;
  margin-bottom: 12px;
  opacity: 0.6;
  transition: all 0.3s ease;
  filter: grayscale(10%);
}

.construction-upload-add:hover .verifyimg {
  opacity: 1;
  filter: grayscale(0%);
  transform: scale(1.05);
}

.construction-upload-add .textfont {
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  line-height: 1.5;
  color: #888;
  transition: all 0.3s ease;
  word-break: break-word;
}

.construction-upload-add:hover .textfont {
  color: #1989fa;
  font-weight: 600;
}

.carcode-input {
  text-align: right;
}

input::-webkit-input-placeholder {
  text-align: right;
}
a:link {
  color: #333333;
  /* text-decoration:underline; */
}

/* 图片预览模态框样式 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 30px;
  color: #fff;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  z-index: 2;
}

/* 施工示例图样式 */
.construction-examples {
  margin-top: 15px;
}

.examples-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.construction-example-item {
  width: calc(25% - 8px);
  background-color: #f2f2f2;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.construction-example-label {
  width: 100%;
  height: 25px;
  font-size: 12px;
  background-color: #4cd964;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.construction-example-item .example {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

/* 更新示例框样式 */
.examplebox {
  width: 120px;
  height: 100%;
  background-color: #f2f2f2;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  /* padding: 20px;
  box-sizing: border-box; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.exampletext {
  width: 50px;
  height: 20px;
  font-size: 12px;
  background-color: #4cd964;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.examplebox .example {
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-bottom: 12px;
}

.construction-example-item .example {
  width: 100%;
  height: 100px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/verify/verifyMesg.vue